import '../css/license.css'; // Common styles for info blocks
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js'
import { t } from 'ttag';
import ProgressBar from './ProgressBar';
import React, { useEffect, useState, useRef } from 'react';
import { Loading } from '../components/loading.js';
import { Turl } from '../components/tUrl.js'

const tg = window.Telegram ? window.Telegram.WebApp : null;

function License({ recData, handlesetIndex }) {
    const [mData, setmData] = useState(null);
    const hasFetchedData = useRef(false); // Ref для отслеживания первого вызова

    useEffect(() => {
        const getData = async () => {
            hasFetchedData.current = true;

            try {
                const _userData = tg ? tg.initData : null;
                let userData = { initData: _userData }


                if (userData) {
                    const response = await fetch(Turl + '/st/license', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userData)
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    let rd = await response.json();
                    console.log(rd);
                    setmData(rd)

                } else {
                    console.warn("Telegram user data not available.");
                }

            } catch (error) {
                console.error('Authentication error:', error);
            }
        };

        if (!mData && !hasFetchedData.current) {
            getData();
        }
    }, [mData]);

    if (!mData)
        return <Loading />;
    hasFetchedData.current = false;

    // --- Список активных лицензий пользователя ---
    const userLicList = recData.user_lic.map((element, index) => (
        <div className='l-sub-block' key={index}>
            <div className="l-data-row">
                <div className="l-data-label">{element.name}</div>
                <div className="l-data-value">
                    {formatNumberWithCommas(element.profit, 2)} / {formatNumberWithCommas(element.price, 0)} USDT
                </div>
            </div>
            <ProgressBar
                completed={((element.profit) / element.price) * 100}
                bgColor="#2196f3" // Вы можете изменить этот цвет
                height="10px"
            />
        </div>
    ));

    // --- Список всех доступных лицензий (из mData) ---
    const allLicList = mData.data.map((element, index) => (
        <div className='l-data-row' key={index}>
            <div className='l-data-label'>{element.name}</div>
            <div className='l-data-value l-value-center'>{element.count}</div>
        </div>
    ));

    // --- Блок "License Pool" ---
    const stat = (
        <div className='l-main-block'>
            {/* Главная строка "License pool" */}
            <div className='l-data-row l-pool-header'>
                <div className='l-data-label'>{t`License pool`}</div>
                <div className='l-data-value'>
                    {formatNumberWithCommas(recData.lic_pool, 0)} USDT
                </div>
            </div>
            {/* Список всех лицензий */}
            {allLicList}
        </div>
    );

    // --- Кнопка "Buy" ---
    const buy = (
        <button className="l-action-button" onClick={() => { handlesetIndex(31) }}>
            {t`Buy license`}
        </button>
    );

    // --- Блок "Active License" ---
    const bal = (
        <div className='l-main-block'>
            {/* Заголовок "Active License" */}
            <div className='l-data-row l-active-header'>
                <div className='l-data-label'>{t`Active License:`}</div>
                <div className='l-data-value'>
                    {recData.user_lic.length === 0 ? "No" : ""}
                </div>
            </div>
            {/* Список лицензий пользователя */}
            {userLicList}
        </div>
    );

    return <>{stat} {buy} {bal}</>
}

export { License };